import { render, staticRenderFns } from "./AuthPublicCorporation.vue?vue&type=template&id=10ce14d4&"
import script from "./AuthPublicCorporation.vue?vue&type=script&lang=js&"
export * from "./AuthPublicCorporation.vue?vue&type=script&lang=js&"
import style0 from "./AuthPublicCorporation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports